/**
 * Full DD Workflow Tour
 *
 * Multi-page walkthrough showing the complete Due Diligence workflow.
 * Guides users through configuration -> upload -> analysis -> reporting.
 */

import { TourDefinition } from '../config/tourSteps';

export const fullDDWorkflowTour: TourDefinition = {
  id: 'fullDDWorkflowTour',
  steps: [
    {
      popover: {
        title: 'Complete DD Workflow',
        description:
          'Deze rondleiding laat zien hoe het volledige due diligence proces werkt in YallyHub. We beginnen bij de configuratie en eindigen bij de rapportage.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      popover: {
        title: 'Stap 1: Configuratie',
        description:
          'Eerst configureert u de DD-categorieën en vragen in de instellingen. U koppelt bestandslabels aan vragen zodat de AI automatisch documenten kan analyseren.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      popover: {
        title: 'Volgende: DD Configuratie',
        description:
          'Klik op "Volgende" om naar de DD configuratiepagina te gaan waar we de setup uitleggen.',
        side: 'bottom',
        align: 'center',
      },
    },
  ],
  nextPageUrl: '/settings',
  nextTourId: 'ddSettingsTour',
};
